import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { PensionOption } from "../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { Money } from "../../../../../../../Wrap/Core/DataTypes/Money";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import {getAvailableCashAfterDeduction} from "./Helper/DrawdownDetailHelper";


interface IPCLSSectionProps extends IProcessComponentProps {
    data: DrawdownModel;
    hidePCLSSection?: boolean;
}

interface IPCLSSectionState { }

export class PCLSSection extends ProcessComponent<IPCLSSectionProps, IPCLSSectionState> {
    constructor(props: IPCLSSectionProps) {
        super(props);
    }

    public render(): JSX.Element {
        const { data } = this.props;
        const ufplsWithdrawalAmount = data?.UfplsWithdrawal?.WithdrawalAmount;
        const maximumUfplsAvailable = data?.DrawdownCalculations?.AvailableCash;
        const pclsAmount =
        data?.DrawdownType == DrawdownType.Regular
            ? {
                  Amount: 0.25 * (data?.RegularCrystallisationDetails?.Amount?.Amount || 0),
                  Currency: data?.RegularCrystallisationDetails?.Amount?.Currency,
              }
            : data?.TaxFreeLumpSum;
        return (
            <div>
                {data?.PensionOption !== PensionOption.UFPLS ? (
                    <div>
                        {data?.PensionOption == PensionOption.Drawdown && (
                            <>
                                {!this.props.hidePCLSSection && 
                                    <div className="row">
                                        <div className="col-12 col-xs-7">
                                            <div className="panel-blue mt-30">
                                                <h3 className="mb-5">Pension Commencement Lump Sum entitlement:</h3>
                                                <span>{MoneyDisplayHelper.getMoneyFormat(pclsAmount)}</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {data?.DrawdownCalculations?.HasFailedStandaloneLumpSumValidation && (
                                    <Alert
                                        alertType={AlertType.Error}
                                        message="The calculated amount would be a Standalone Lump Sum, please contact us to proceed with this payment"
                                    />
                                )}
                                {data?.DrawdownCalculations?.HasStopWarning && (
                                    <Alert
                                        alertType={AlertType.Error}
                                        message="The calculated amount is equal to the amount requested for crystallisation. Please contact us"
                                    />
                                )}
                                <div className="row">
                                    <div className="col-12 col-xs-7">
                                        <div className="panel-blue">
                                            <h3 className="mb-5">
                                                Available cash after deduction of tax free lump sum:
                                            </h3>
                                            <span>
                                                {MoneyDisplayHelper.getMoneyFormat({
                                                    Amount: getAvailableCashAfterDeduction(data),
                                                    Currency:  data?.CrystallisationDetails?.AvailableCash?.Currency,
                                                })}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ) : null}
            </div>
        );
    }
}
